import React, { useRef, useState, useEffect } from 'react';
import { ChevronRight } from 'lucide-react';
import { Tooltip } from '@mui/material';

import {
  Banner,
  BannerContent,
  IconContainer,
  LogoContainer,
  BannerImage,
  BannerTitle,
  BannerSubtitle,
} from './styles';
import TrialImage from '../../../assets/images/APC logo.png';
import { BannerApcProps } from './types';
import { TranslationKeys } from '../../../i18n/locales/defaultResources';
import { useI18n } from '../../../hooks/useI18n';

const BannerApc: React.FC<BannerApcProps> = ({ onClick }) => {
  const { t } = useI18n();
  const subheadlineRef = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);
  useEffect(() => {
    const checkOverflow = () => {
      if (subheadlineRef.current) {
        const isOverflowing =
          subheadlineRef.current.scrollHeight >
          subheadlineRef.current.clientHeight;
        setShowTooltip(isOverflowing);
      }
    };
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, [t(TranslationKeys.bannerapc_subtitle)]);
  const subheadlineContent = t(TranslationKeys.bannerapc_subtitle);
  const subheadlineElement = showTooltip ? (
    <Tooltip
      title={subheadlineContent}
      arrow
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -8],
            },
          },
        ],
      }}
    >
      <BannerSubtitle ref={subheadlineRef}>{subheadlineContent}</BannerSubtitle>
    </Tooltip>
  ) : (
    <BannerSubtitle ref={subheadlineRef}>{subheadlineContent}</BannerSubtitle>
  );
  return (
    <Banner onClick={onClick}>
      <LogoContainer>
        <BannerImage
          src={TrialImage}
          alt={t(TranslationKeys.bannerapc_image_alt) as string}
        />
      </LogoContainer>
      <BannerContent>
        <BannerTitle>{t(TranslationKeys.bannerapc_title)}</BannerTitle>
        {subheadlineElement}
      </BannerContent>
      <IconContainer>
        <ChevronRight size={24} />
      </IconContainer>
    </Banner>
  );
};
export default BannerApc;
